"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Question_1 = require("./Question");
var Answer_1 = require("./Answer");
var Recommendation_1 = require("./Recommendation");
var stringHelper_1 = require("../utils/stringHelper");
var numberFormatter_1 = require("../utils/numberFormatter");
var Persistence_1 = require("../Persistence/Persistence");
var ASCVDRiskCalculator_1 = require("./ASCVDRiskCalculator");
var BleedingScoreCalculator_1 = require("./BleedingScoreCalculator");
var constants = require("../constants/constants");
var ASCVDRiskCalculator_2 = require("./ASCVDRiskCalculator");
var bleedingRisk = require("./BleedingRisk");
var mathHelper_1 = require("../utils/mathHelper");
var RecommendationAlgorithm = /** @class */ (function () {
    function RecommendationAlgorithm() {
        this.startQuestion = new Question_1.default();
        this.introQuestion = new Question_1.default();
        this.cardioDiseaseQuestion = new Question_1.default();
        this.cardioDiseaseContinueQuestion = new Question_1.default();
        this.aspirinContraindicationsQuestion = new Question_1.default();
        this.sexQuestion = new Question_1.default();
        this.raceQuestion = new Question_1.default();
        this.ageQuestion = new Question_1.default();
        this.tooOldQuestion = new Question_1.default();
        this.tooYoungQuestion = new Question_1.default();
        this.pregnancyQuestion = new Question_1.default();
        this.smokerQuestion = new Question_1.default();
        this.bloodPressureMedicationQuestion = new Question_1.default();
        this.systolicBloodPressureQuestion = new Question_1.default();
        this.diabetesQuestion = new Question_1.default();
        this.cholesterolLoweringMedicationsQuestion = new Question_1.default();
        this.totalCholesterolQuestion = new Question_1.default();
        this.hdlCholesterolQuestion = new Question_1.default();
        this.atrialFibrillationQuestion = new Question_1.default();
        this.ulcerQuestion = new Question_1.default();
        this.complicatedUlcerQuestion = new Question_1.default();
        this.dyspepsiaQuestion = new Question_1.default();
        this.nsaidsQuestion = new Question_1.default();
        this.prednisoneQuestion = new Question_1.default();
        this.confirmQuestion = new Question_1.default();
        this.loadStartQuestion();
        this.loadCardioDiseaseQuestion();
        this.loadCardioDiseaseContinueQuestion();
        this.loadAspirinContraindicationsQuestion();
        this.loadIntroQuestion();
        this.loadSexQuestion();
        this.loadRaceQuestion();
        this.loadAgeQuestion();
        this.loadTooOldQuestion();
        this.loadTooYoungQuestion();
        this.loadPregnancyQuestion();
        this.loadSmokerQuestion();
        this.loadBloodPressureMedicationQuestion();
        this.loadSystolicBloodPressureMedicationQuestion();
        this.loadDiabetesQuestion();
        this.loadCholesterolLoweringMedicationsQuestion();
        this.loadTotalCholesterolQuestion();
        this.loadHDLCholesterolQuestion();
        this.loadAtrialFibrillationQuestion();
        this.loadUlcerQuestion();
        this.loadComplicatedUlcerQuestion();
        this.loadDyspepsiaQuestion();
        this.loadNSAIDSQuestion();
        this.loadPrednisoneQuestion();
        this.loadConfirmQuestion();
        // RecommendationAlgorithm.testNNT();
    }
    RecommendationAlgorithm.prototype.loadStartQuestion = function () {
        this.startQuestion.title = "Start";
        this.startQuestion.questionText = "Aspirin-Guide incorporates information about the patient’s risk factors to calculate a 10-yr ASCVD risk score (the ACC/AHA ASCVD score) and a bleeding risk score, to help clinicians implement clinical guidelines on the use of aspirin in primary prevention.\n\tTap the \"Learn More\" button below for more information and to see a summary of the decision-making algorithm.";
        var startAnswer = Answer_1.MultipleChoiceAnswer.multipleChoiceAnswerWithText("Start", this.cardioDiseaseQuestion, null);
        var learnMore = Answer_1.MultipleChoiceAnswer.multipleChoiceAnswerWithText("Learn\nMore", null, null);
        learnMore.isLearnMore = true;
        this.startQuestion.multipleChoiceAnswers = [startAnswer, learnMore];
    };
    RecommendationAlgorithm.prototype.loadIntroQuestion = function () {
        this.introQuestion.questionText = "The Aspirin-Guide app from researchers at Brigham and Women’s Hospital, Harvard Medical School, helps clinicians decide which patients are candidates for the use of low-dose aspirin (75-100 mg/d) in the primary prevention of atherosclerotic cardiovascular disease (ASCVD) by balancing the ASCVD benefits against the risk of harm due to gastrointestinal (GI) or other bleeding.";
        this.introQuestion.isIntroQuestion = true;
        var start = new Answer_1.MultipleChoiceAnswer();
        start.answerText = "Continue";
        start.nextQuestion = this.startQuestion;
        this.introQuestion.multipleChoiceAnswers = [start];
    };
    RecommendationAlgorithm.prototype.loadCardioDiseaseQuestion = function () {
        var diseases = ["myocardial infarction", "angina pectoris",
            "coronary revascularization (coronary artery bypass graft or angioplasty/stent)", "ischemic stroke",
            "peripheral vascular disease/claudication"];
        var bulletedList = stringHelper_1.default.BulletedList(diseases, null, null);
        this.cardioDiseaseQuestion.questionText = "Does the patient have a prior history of atherosclerotic cardiovascular disease (ASCVD), including one or more of the following?\n"
            + bulletedList;
        var yes = Answer_1.MultipleChoiceAnswer.yesAnswer(this.cardioDiseaseContinueQuestion, null);
        var no = Answer_1.MultipleChoiceAnswer.noAnswer(this.aspirinContraindicationsQuestion, null);
        this.cardioDiseaseQuestion.multipleChoiceAnswers = [yes, no];
    };
    RecommendationAlgorithm.prototype.loadAspirinContraindicationsQuestion = function () {
        var contraindications = ["hypersensitivity/allergy to aspirin", "prior intracranial bleed",
            "serious GI bleed requiring hospitalization or blood transfusion", "recent bleeding",
            "concomitant anticoagulant or other antiplatelet medication use", "severe kidney or liver disease"];
        var bulletedList = stringHelper_1.default.BulletedList(contraindications, null, null);
        this.aspirinContraindicationsQuestion.questionText = "Does the patient have one or more of the following MAJOR contraindications to aspirin?\n" + bulletedList;
        var yes = Answer_1.MultipleChoiceAnswer.yesAnswer(null, null);
        var no = Answer_1.MultipleChoiceAnswer.noAnswer(this.ageQuestion, null);
        this.aspirinContraindicationsQuestion.multipleChoiceAnswers = [yes, no];
    };
    RecommendationAlgorithm.prototype.loadCardioDiseaseContinueQuestion = function () {
        this.cardioDiseaseContinueQuestion.questionText = "Advise low-dose daily aspirin (75-100 mg/d) unless the patient has one or more of the following MAJOR contraindications to aspirin:  hypersensitivity/allergy to aspirin, prior intracranial bleed, serious GI bleed requiring hospitalization or blood transfusion, or recent bleeding. If the patient has a history of serious GI bleeding but is still a candidate for aspirin, recommend GI prophylaxis with a proton pump inhibitor (PPI)[[ppiExamples]] or H2 blockers[[h2Examples]]. If patient has a history of peptic ulcer disease, recommend GI prophylaxis with PPI and treatment to eradicate H. pylori.[[4]][[5]]\n\nPress continue to calculate the patient's CVD risk and bleeding risk and to compare the benefits and risks of aspirin.";
        var continueAnswer = Answer_1.MultipleChoiceAnswer.multipleChoiceAnswerWithText("Continue", this.aspirinContraindicationsQuestion, null);
        this.cardioDiseaseContinueQuestion.multipleChoiceAnswers = [continueAnswer];
    };
    RecommendationAlgorithm.prototype.loadAgeQuestion = function () {
        var _this = this;
        this.ageQuestion.title = "Age";
        this.ageQuestion.questionText = "What is the patient's age?";
        var inputAnswer = new Answer_1.InputAnswer();
        inputAnswer.isIntegerValue = true;
        inputAnswer.minValue = 30;
        inputAnswer.maxValue = 120;
        this.ageQuestion.inputAnswer = inputAnswer;
        inputAnswer.nextQuestionBlock = function () {
            var age = _this.ageQuestion.inputAnswer.selectedValue;
            var nextQuestion = null;
            if (age >= 70) {
                nextQuestion = _this.tooOldQuestion;
            }
            else if (age < 40) {
                nextQuestion = _this.tooYoungQuestion;
            }
            else {
                nextQuestion = _this.sexQuestion;
            }
            return nextQuestion;
        };
    };
    RecommendationAlgorithm.prototype.loadTooOldQuestion = function () {
        this.tooOldQuestion.questionText = "Individuals age 70 or older are generally not considered appropriate candidates for initiating aspirin therapy in primary prevention. Would you like to continue?";
        var continueAnswer = Answer_1.MultipleChoiceAnswer.multipleChoiceAnswerWithText("Continue", this.sexQuestion, null);
        this.tooOldQuestion.multipleChoiceAnswers = [continueAnswer];
    };
    RecommendationAlgorithm.prototype.loadTooYoungQuestion = function () {
        this.tooYoungQuestion.questionText = "Individuals below age 40 are generally not considered appropriate candidates for initiating aspirin therapy in primary prevention. Would you like to continue?";
        var continueAnswer = Answer_1.MultipleChoiceAnswer.multipleChoiceAnswerWithText("Continue", this.sexQuestion, null);
        this.tooYoungQuestion.multipleChoiceAnswers = [continueAnswer];
    };
    RecommendationAlgorithm.prototype.loadSexQuestion = function () {
        var _this = this;
        this.sexQuestion.title = "Sex";
        this.sexQuestion.questionText = "What is the patient's sex?";
        var maleAnswer = Answer_1.MultipleChoiceAnswer.multipleChoiceAnswerWithText("Male", this.raceQuestion, null);
        var femaleAnswer = Answer_1.MultipleChoiceAnswer.multipleChoiceAnswerWithText("Female", null, null);
        femaleAnswer.nextQuestionBlock = function () {
            var age = _this.ageQuestion.inputAnswer.selectedValue;
            var nextQuestion = null;
            if (age <= 52) {
                nextQuestion = _this.pregnancyQuestion;
            }
            else {
                nextQuestion = _this.raceQuestion;
            }
            return nextQuestion;
        };
        this.sexQuestion.multipleChoiceAnswers = [maleAnswer, femaleAnswer];
    };
    RecommendationAlgorithm.prototype.loadPregnancyQuestion = function () {
        this.pregnancyQuestion.title = "Pregnancy";
        this.pregnancyQuestion.questionText = "Is the patient pregnant?";
        var yesAnswer = Answer_1.MultipleChoiceAnswer.yesAnswer(null, null);
        var noAnswer = Answer_1.MultipleChoiceAnswer.noAnswer(this.raceQuestion, null);
        this.pregnancyQuestion.multipleChoiceAnswers = [yesAnswer, noAnswer];
    };
    RecommendationAlgorithm.prototype.loadRaceQuestion = function () {
        this.raceQuestion.title = "Race";
        this.raceQuestion.questionText = "What is the patient's race/ethnicity?";
        var answerOptions = ["White", "Black", "Asian", "Hispanic", "Other"];
        var multipleChoiceAnswers = [];
        for (var _i = 0, answerOptions_1 = answerOptions; _i < answerOptions_1.length; _i++) {
            var opt = answerOptions_1[_i];
            var answer = Answer_1.MultipleChoiceAnswer.multipleChoiceAnswerWithText(opt, this.smokerQuestion, null);
            multipleChoiceAnswers.push(answer);
        }
        this.raceQuestion.multipleChoiceAnswers = multipleChoiceAnswers;
    };
    RecommendationAlgorithm.prototype.loadSmokerQuestion = function () {
        this.smokerQuestion.title = "Smoker";
        this.smokerQuestion.questionText = "Is the patient a current smoker?";
        var yesAnswer = Answer_1.MultipleChoiceAnswer.yesAnswer(this.bloodPressureMedicationQuestion, null);
        var noAnswer = Answer_1.MultipleChoiceAnswer.noAnswer(this.bloodPressureMedicationQuestion, null);
        this.smokerQuestion.multipleChoiceAnswers = [yesAnswer, noAnswer];
    };
    RecommendationAlgorithm.prototype.loadBloodPressureMedicationQuestion = function () {
        this.bloodPressureMedicationQuestion.title = "Hypertension Medication";
        this.bloodPressureMedicationQuestion.questionText = "Does the patient currently take medication for high blood pressure?";
        var yesAnswer = Answer_1.MultipleChoiceAnswer.yesAnswer(this.systolicBloodPressureQuestion, null);
        var noAnswer = Answer_1.MultipleChoiceAnswer.noAnswer(this.systolicBloodPressureQuestion, null);
        this.bloodPressureMedicationQuestion.multipleChoiceAnswers = [yesAnswer, noAnswer];
    };
    RecommendationAlgorithm.prototype.loadSystolicBloodPressureMedicationQuestion = function () {
        this.systolicBloodPressureQuestion.title = "Systolic BP";
        this.systolicBloodPressureQuestion.questionText = "What is the patient's systolic blood pressure?";
        var inputAnswer = new Answer_1.InputAnswer();
        inputAnswer.minValue = 80;
        inputAnswer.maxValue = 220;
        inputAnswer.unitsSI = "mmHg";
        inputAnswer.unitsUS = "mmHg";
        inputAnswer.nextQuestion = this.diabetesQuestion;
        this.systolicBloodPressureQuestion.inputAnswer = inputAnswer;
    };
    RecommendationAlgorithm.prototype.loadDiabetesQuestion = function () {
        this.diabetesQuestion.title = "Diabetes";
        this.diabetesQuestion.questionText = "Does the patient have diabetes?";
        var yesAnswer = Answer_1.MultipleChoiceAnswer.yesAnswer(this.cholesterolLoweringMedicationsQuestion, null);
        var noAnswer = Answer_1.MultipleChoiceAnswer.noAnswer(this.cholesterolLoweringMedicationsQuestion, null);
        this.diabetesQuestion.multipleChoiceAnswers = [yesAnswer, noAnswer];
    };
    RecommendationAlgorithm.prototype.loadCholesterolLoweringMedicationsQuestion = function () {
        this.cholesterolLoweringMedicationsQuestion.title = "Cholesterol Medication";
        this.cholesterolLoweringMedicationsQuestion.questionText = "Does the patient take statins or other cholesterol-lowering medication?";
        var yesAnswer = Answer_1.MultipleChoiceAnswer.yesAnswer(this.totalCholesterolQuestion, null);
        var noAnswer = Answer_1.MultipleChoiceAnswer.noAnswer(this.totalCholesterolQuestion, null);
        this.cholesterolLoweringMedicationsQuestion.multipleChoiceAnswers = [yesAnswer, noAnswer];
    };
    RecommendationAlgorithm.prototype.loadTotalCholesterolQuestion = function () {
        this.totalCholesterolQuestion.title = "Total Cholesterol";
        this.totalCholesterolQuestion.questionText = "What is the patient's total cholesterol level?";
        var inputAnswer = new Answer_1.InputAnswer();
        inputAnswer.minValue = 50;
        inputAnswer.maxValue = 500;
        inputAnswer.unitsSI = "mmol/L";
        inputAnswer.unitsUS = "mg/dL";
        inputAnswer.nextQuestion = this.hdlCholesterolQuestion;
        this.totalCholesterolQuestion.inputAnswer = inputAnswer;
    };
    RecommendationAlgorithm.prototype.loadHDLCholesterolQuestion = function () {
        this.hdlCholesterolQuestion.title = "HDL Cholesterol";
        this.hdlCholesterolQuestion.questionText = "What is the patient's HDL-cholesterol level?";
        var inputAnswer = new Answer_1.InputAnswer();
        inputAnswer.minValue = 10;
        inputAnswer.maxValue = 150;
        inputAnswer.unitsSI = "mmol/L";
        inputAnswer.unitsUS = "mg/dL";
        inputAnswer.nextQuestion = this.atrialFibrillationQuestion;
        this.hdlCholesterolQuestion.inputAnswer = inputAnswer;
    };
    RecommendationAlgorithm.prototype.loadAtrialFibrillationQuestion = function () {
        this.atrialFibrillationQuestion.title = "Atrial Fibrillation";
        this.atrialFibrillationQuestion.questionText = "Does the patient have atrial fibrillation OR does he/she already take an anticoagulant/antiplatelet agent[[a]]?";
        var yesAnswer = Answer_1.MultipleChoiceAnswer.yesAnswer(null, null);
        var noAnswer = Answer_1.MultipleChoiceAnswer.noAnswer(this.ulcerQuestion, null);
        this.atrialFibrillationQuestion.multipleChoiceAnswers = [yesAnswer, noAnswer];
    };
    RecommendationAlgorithm.prototype.loadUlcerQuestion = function () {
        this.ulcerQuestion.title = "Peptic Ulcer";
        this.ulcerQuestion.questionText = "Does the patient have a history of an upper gastrointestinal tract (peptic) ulcer?";
        var yes = Answer_1.MultipleChoiceAnswer.yesAnswer(this.complicatedUlcerQuestion, null);
        var no = Answer_1.MultipleChoiceAnswer.noAnswer(this.dyspepsiaQuestion, null);
        this.ulcerQuestion.multipleChoiceAnswers = [yes, no];
    };
    RecommendationAlgorithm.prototype.loadComplicatedUlcerQuestion = function () {
        this.complicatedUlcerQuestion.title = "Complicated Ulcer";
        this.complicatedUlcerQuestion.questionText = "Was the ulcer complicated by bleeding or perforation?";
        var yes = Answer_1.MultipleChoiceAnswer.yesAnswer(this.nsaidsQuestion, null);
        var no = Answer_1.MultipleChoiceAnswer.noAnswer(this.dyspepsiaQuestion, null);
        this.complicatedUlcerQuestion.multipleChoiceAnswers = [yes, no];
    };
    RecommendationAlgorithm.prototype.loadDyspepsiaQuestion = function () {
        this.dyspepsiaQuestion.title = "Dyspepsia/GI Pain";
        this.dyspepsiaQuestion.questionText = "Does the patient have a history of upper gastrointestinal pain or dyspepsia?";
        var yes = Answer_1.MultipleChoiceAnswer.yesAnswer(this.nsaidsQuestion, null);
        var no = Answer_1.MultipleChoiceAnswer.noAnswer(this.nsaidsQuestion, null);
        this.dyspepsiaQuestion.multipleChoiceAnswers = [yes, no];
    };
    RecommendationAlgorithm.prototype.loadNSAIDSQuestion = function () {
        this.nsaidsQuestion.title = "Regular NSAID use";
        this.nsaidsQuestion.questionText = "Does the patient regularly use the following (currently or in the past 30 days, prescription or over-the-counter at least 2-3 times per week):  oral non-aspirin non-steroidal anti-inflammatory drugs (NSAIDs)[[b]]?";
        var yes = Answer_1.MultipleChoiceAnswer.yesAnswer(this.prednisoneQuestion, null);
        var no = Answer_1.MultipleChoiceAnswer.noAnswer(this.prednisoneQuestion, null);
        this.nsaidsQuestion.multipleChoiceAnswers = [yes, no];
    };
    RecommendationAlgorithm.prototype.loadPrednisoneQuestion = function () {
        this.prednisoneQuestion.title = "Prednisone/Systemic Corticosteroids";
        this.prednisoneQuestion.questionText = "Does the patient currently use prednisone or other systemic corticosteroids?";
        var yes = Answer_1.MultipleChoiceAnswer.yesAnswer(this.confirmQuestion, null);
        var no = Answer_1.MultipleChoiceAnswer.noAnswer(this.confirmQuestion, null);
        this.prednisoneQuestion.multipleChoiceAnswers = [yes, no];
    };
    RecommendationAlgorithm.prototype.loadConfirmQuestion = function () {
        this.confirmQuestion.isConfirmQuestion = true;
        var confirm = Answer_1.MultipleChoiceAnswer.multipleChoiceAnswerWithText("Confirm", null, null);
        this.confirmQuestion.multipleChoiceAnswers = [confirm];
    };
    RecommendationAlgorithm.prototype.updateConfirmAnswerForQuestions = function () {
        var questionText = "Please confirm that these are the values that you intended to enter. You can use the back button to make corrections.\n\n" + this.answerSummary();
        this.confirmQuestion.questionText = questionText;
    };
    RecommendationAlgorithm.prototype.answerSummary = function () {
        var questionText = "";
        var answeredQuestions = [];
        answeredQuestions.push(this.ageQuestion);
        answeredQuestions.push(this.sexQuestion);
        answeredQuestions.push(this.raceQuestion);
        answeredQuestions.push(this.smokerQuestion);
        answeredQuestions.push(this.bloodPressureMedicationQuestion);
        answeredQuestions.push(this.systolicBloodPressureQuestion);
        answeredQuestions.push(this.diabetesQuestion);
        answeredQuestions.push(this.cholesterolLoweringMedicationsQuestion);
        answeredQuestions.push(this.totalCholesterolQuestion);
        answeredQuestions.push(this.hdlCholesterolQuestion);
        answeredQuestions.push(this.atrialFibrillationQuestion);
        answeredQuestions.push(this.ulcerQuestion);
        if (this.complicatedUlcerQuestion.selectedAnswer != null) {
            answeredQuestions.push(this.complicatedUlcerQuestion);
        }
        if (this.dyspepsiaQuestion.selectedAnswer) {
            answeredQuestions.push(this.dyspepsiaQuestion);
        }
        answeredQuestions.push(this.nsaidsQuestion);
        answeredQuestions.push(this.prednisoneQuestion);
        for (var _i = 0, answeredQuestions_1 = answeredQuestions; _i < answeredQuestions_1.length; _i++) {
            var question = answeredQuestions_1[_i];
            var answerText = null;
            if (question.selectedAnswer instanceof Answer_1.MultipleChoiceAnswer) {
                var choice = question.selectedAnswer;
                answerText = choice.answerText;
            }
            else if (question.inputAnswer != null) {
                var answer = question.inputAnswer;
                if (answer.unitsSI) {
                    var useSI = Persistence_1.default.usesSIUnits() && answer.unitsUS != answer.unitsSI;
                    var units = answer.unitsSI;
                    var value = answer.selectedValue;
                    if (useSI) {
                        value /= constants.kmmollTOmgdl;
                    }
                    else if (!useSI) {
                        units = answer.unitsUS;
                    }
                    var valueString = numberFormatter_1.default.getFormattedNumber(value);
                    answerText = valueString + " " + units;
                }
                else {
                    answerText = answer.selectedValue;
                }
            }
            questionText += question.title + ": " + answerText + "\n";
        }
        return questionText;
    };
    RecommendationAlgorithm.prototype.recommendationForAnswers = function () {
        var recommendation = null;
        var hasMajorContraindicationsToAspirin = this.aspirinContraindicationsQuestion.answeredYes();
        var patientPregnant = this.pregnancyQuestion.answeredYes();
        var hasAtrialFibrillation = this.atrialFibrillationQuestion.answeredYes();
        var age = this.ageQuestion.inputAnswer.selectedValue;
        var lastQuestion = this.nsaidsQuestion;
        if (hasMajorContraindicationsToAspirin) {
            var historyOfCVD = this.cardioDiseaseQuestion.answeredYes();
            recommendation = this.hasMajorContraindicationsToAspirinRecommendation(historyOfCVD);
        }
        else if (patientPregnant) {
            recommendation = this.patientPregnantRecommendation();
        }
        else if (hasAtrialFibrillation) {
            recommendation = this.atrialFibrillationRecommendation();
        }
        else if (lastQuestion.selectedAnswer != null) {
            var sexAnswer = this.sexQuestion.selectedAnswer;
            var gender = sexAnswer.answerText == "Male" ? constants.Gender.Male : constants.Gender.Female;
            var riskScoreParams = new ASCVDRiskCalculator_2.ASCVDRiskScoreParams();
            riskScoreParams.isSmoker = this.smokerQuestion.answeredYes();
            riskScoreParams.treatedForHypertension = this.bloodPressureMedicationQuestion.answeredYes();
            riskScoreParams.hasDiabetes = this.diabetesQuestion.answeredYes();
            var race = constants.Race.White;
            var raceAnswer = this.raceQuestion.selectedAnswer;
            var raceAnswerText = raceAnswer.answerText;
            if (raceAnswerText == "Black") {
                race = constants.Race.Black;
            }
            else if (raceAnswerText == "Asian") {
                race = constants.Race.Asian;
            }
            else if (raceAnswerText == "Hispanic") {
                race = constants.Race.Hispanic;
            }
            riskScoreParams.race = race;
            riskScoreParams.gender = gender;
            riskScoreParams.age = age;
            riskScoreParams.totalCholesterol = this.totalCholesterolQuestion.inputAnswer.selectedValue;
            riskScoreParams.hdlCholesterol = this.hdlCholesterolQuestion.inputAnswer.selectedValue;
            var systolicBloodPressure = this.systolicBloodPressureQuestion.inputAnswer.selectedValue;
            riskScoreParams.systolicBloodPressure = systolicBloodPressure;
            var ascvdScore = ASCVDRiskCalculator_1.default.riskScore(riskScoreParams);
            var prednisoneUse = this.prednisoneQuestion.answeredYes();
            var nsaidUse = this.nsaidsQuestion.answeredYes();
            var coagulant = this.atrialFibrillationQuestion.answeredYes();
            var dyspepsia = this.dyspepsiaQuestion.answeredYes();
            var cholesterolLoweringMeds = this.cholesterolLoweringMedicationsQuestion.answeredYes();
            var ulcer = this.ulcerQuestion.answeredYes();
            var complicatedUlcer = this.complicatedUlcerQuestion.answeredYes();
            var bleedingRisks = new Array();
            if (age >= 60) {
                bleedingRisks.push(bleedingRisk.kBleedingRiskAge);
            }
            if (gender == constants.Gender.Male) {
                bleedingRisks.push(bleedingRisk.kBleedingRiskMale);
            }
            if (nsaidUse) {
                bleedingRisks.push(bleedingRisk.kBleedingRiskNSAID);
            }
            if (prednisoneUse) {
                bleedingRisks.push(bleedingRisk.kBleedingRiskPrednisone);
            }
            if (coagulant) {
                bleedingRisks.push(bleedingRisk.kBleedingRiskCoagulant);
            }
            if (dyspepsia) {
                bleedingRisks.push(bleedingRisk.kBleedingRiskDyspepsia);
            }
            if (ulcer) {
                bleedingRisks.push(bleedingRisk.kBleedingRiskUlcer);
            }
            if (complicatedUlcer) {
                bleedingRisks.push(bleedingRisk.kBleedingRiskComplicatedUlcer);
            }
            var bleedingScore = BleedingScoreCalculator_1.default.BleedingRiskScore(age, gender, bleedingRisks);
            var highBloodPressure = systolicBloodPressure >= 150;
            var historyOfCVD = this.cardioDiseaseQuestion.answeredYes();
            recommendation = RecommendationAlgorithm.recommendationForASCVDScore(ascvdScore, bleedingScore, gender, age, bleedingRisks, highBloodPressure, cholesterolLoweringMeds, historyOfCVD, riskScoreParams.hasDiabetes);
        }
        return recommendation;
    };
    RecommendationAlgorithm.recommendationForASCVDScore = function (ascvdScore, bleedingScore, gender, age, giRiskFactors, highBloodPressure, usesCholesterolLoweringMeds, historyOfCVD, hasDiabetes) {
        if (historyOfCVD) {
            ascvdScore = Math.max(25, ascvdScore);
        }
        var bleedingRiskScore = BleedingScoreCalculator_1.default.BleedingRiskScore(age, gender, giRiskFactors);
        var nnh = BleedingScoreCalculator_1.default.NNHForBleedingScore(bleedingRiskScore);
        var nnhProphylaxis = 2 * nnh;
        var nnt = ASCVDRiskCalculator_1.default.NNTForScore(ascvdScore);
        var tenYearBleedingRisk = bleedingScore * 10;
        var recommendAspirin = false;
        var considerAspirin = false;
        var clinicalJudgementAppropriateString = " However, clinical judgment is appropriate for individual decision making.";
        var yesAspirin = "For patients with this balance of benefits and risks of aspirin and who are willing to take long-term therapy, the use of aspirin is generally advised in the primary prevention setting.";
        var noAspirin = "For patients who have this balance of benefits and risks of aspirin, the use of aspirin is generally not advised in the primary prevention setting.";
        var considerAspirinString = "For patients with this balance of benefits and risks of aspirin, and who are willing to take long-term therapy, the use of aspirin should be considered in the primary prevention setting.";
        var noAspirinOver70 = "Individuals age 70 or older are generally not considered appropriate candidates for initiating aspirin therapy in primary prevention";
        var noAspirinTooYoung = "Do not advise initiating aspirin because the age is below 40. However, clinical judgment is appropriate for individual decision making.";
        var prophylaxisRiskFactorsCount = 0;
        var prophylaxisRiskFactors = [bleedingRisk.kBleedingRiskUlcer, bleedingRisk.kBleedingRiskComplicatedUlcer, bleedingRisk.kBleedingRiskNSAID, bleedingRisk.kBleedingRiskPrednisone];
        for (var _i = 0, giRiskFactors_1 = giRiskFactors; _i < giRiskFactors_1.length; _i++) {
            var risk = giRiskFactors_1[_i];
            if (prophylaxisRiskFactors.indexOf(risk) > -1) {
                prophylaxisRiskFactorsCount++;
            }
        }
        var recommendationString = "";
        var aspirinRecommendationString = null;
        if ((age >= 40 && age < 60 && ascvdScore >= 10) ||
            (age >= 60 && age < 70 && ascvdScore >= 20) ||
            (age >= 40 && age < 70 && hasDiabetes && ascvdScore >= 10)) {
            if (nnt <= nnh) {
                aspirinRecommendationString = yesAspirin;
                recommendAspirin = true;
            }
            else {
                aspirinRecommendationString = noAspirin;
                recommendAspirin = false;
            }
        }
        else {
            aspirinRecommendationString = noAspirin;
            recommendAspirin = false;
        }
        var aspirinAmount = "75-100 mg/d";
        var yesAspirinSummary = "Advise low-dose aspirin (" + aspirinAmount + ")";
        var noAspirinSummary = "Do not advise aspirin";
        var considerAspirinSummary = "Consider low-dose aspirin (".concat(aspirinAmount, ")");
        var considerAspirinProphylaxisSummary = "Consider low-dose aspirin (".concat(aspirinAmount, ") if concomitant use of GI prophylaxis");
        var highBloodPressureString = "if systolic blood pressure is well-controlled (preferably below 150) before starting aspirin.";
        var yesAspirinHighBPSummary = "".concat(yesAspirinSummary, " ").concat(highBloodPressureString);
        var considerAspirinHighBPSummary = "".concat(considerAspirinSummary, " ").concat(highBloodPressureString);
        var considerAspirinProphylaxisHighBPSummary = "".concat(considerAspirinProphylaxisSummary, " and ").concat(highBloodPressureString);
        var aspirinSummary = null;
        if (recommendAspirin) {
            if (highBloodPressure) {
                aspirinSummary = yesAspirinHighBPSummary;
            }
            else {
                aspirinSummary = yesAspirinSummary;
            }
        }
        else {
            if (age >= 70) {
                aspirinSummary = noAspirinOver70;
            }
            else if (age < 40) {
                aspirinSummary = noAspirinTooYoung;
            }
            else {
                aspirinSummary = noAspirinSummary;
            }
        }
        var bleedingRiskString = "";
        if (giRiskFactors.length == 1) {
            bleedingRiskString += "1 risk factor for increased risk of bleeding";
        }
        else {
            bleedingRiskString += "\n".concat(giRiskFactors.length, " risk factors for increased risk of bleeding");
        }
        if (giRiskFactors.length > 0) {
            var displayNames = [];
            for (var _a = 0, giRiskFactors_2 = giRiskFactors; _a < giRiskFactors_2.length; _a++) {
                var r = giRiskFactors_2[_a];
                displayNames.push(RecommendationAlgorithm.displayNameForBleedingRisk(r));
            }
            var bulletedList = stringHelper_1.default.BulletedList(displayNames, null, null);
            bleedingRiskString += bulletedList;
        }
        bleedingRiskString += "";
        var ascvdScoreString = "".concat(numberFormatter_1.default.getFormattedNumber(ascvdScore), "%");
        if (ascvdScore > 20) {
            ascvdScoreString = ">20%";
        }
        var guidanceSummary = "Guidance: ".concat(aspirinSummary);
        var ascvdRiskSummary = "ASCVD Risk Score: ".concat(ascvdScoreString, " over 10 years without aspirin use.");
        var bleedingRiskSummary = "Bleeding Risk Score: ".concat(numberFormatter_1.default.getFormattedNumber(tenYearBleedingRisk), "% over 10 years without aspirin use. ").concat(bleedingRiskString);
        var nntSummary = "Number Needed to Treat (NNT) with aspirin over 10 years to prevent one ASCVD event: ".concat(nnt);
        var nnhSummary = "Number Needed to Harm (NNH): number needed to treat with aspirin over 10 years to result in one aspirin-related GI bleeding event: ".concat(nnh);
        var nnhGIProphylaxis = "Number Needed to Harm (NNH) with aspirin over 10 years and concomitant GI prophylaxis: ".concat(nnhProphylaxis);
        recommendationString += guidanceSummary;
        recommendationString += "\n\n";
        recommendationString += ascvdRiskSummary;
        recommendationString += "\n\n";
        recommendationString += bleedingRiskSummary;
        recommendationString += "\n\n";
        recommendationString += nntSummary;
        recommendationString += "\n\n";
        recommendationString += nnhSummary;
        recommendationString += "\n\n";
        recommendationString += "**Goal: NNT less than NNH** (i.e., benefit is greater than harm)[[closeRiskScoreExplanation]]";
        recommendationString += "\n\n";
        recommendationString += aspirinRecommendationString;
        var giRiskFactorsString = "\n\tHowever, given the elevated risk of bleeding on aspirin, concomitant GI prophylaxis with a proton pump inhibitor (PPI)  is recommended for patients with a history of GI bleeding or if they have major risk factors for GI bleeding[[4]].  This patient appears to fall in this category. If the patient has a history of peptic ulcer disease, GI prophylaxis with PPI and treatment to eradicate H. pylori are recommended.";
        var youngAgeDisclaimer = "\n\t(Please note that research on aspirin in primary prevention among individuals younger than age 40 is limited.)";
        var closeNNHAndNNTString = "\n\tIf the patient is on the border (NNT and NNH are close, as for this patient), other risk factors such as a strong family history of premature heart disease in a first-degree relative (below age 55 in a male and below age 65 in a female) and the potential for aspirin to reduce the risk of gastrointestinal (in particular colorectal) cancer could be taken into account. In that regard, when the balance of benefits and risks is close, patients may be appropriate candidates for aspirin if they have an increased risk of colorectal cancer[[colorectalDetails]].";
        var canShowCloseNNHAndNNTString = !(age < 40 && ascvdScore < 10) && ascvdScore > 5;
        if (canShowCloseNNHAndNNTString && (mathHelper_1.default.percentDifference(nnt, nnh) < .30)) {
            recommendationString += closeNNHAndNNTString;
        }
        recommendationString += clinicalJudgementAppropriateString;
        if (age < 40 && (considerAspirin || recommendAspirin)) {
            recommendationString += youngAgeDisclaimer;
        }
        var considerStatinsString = "\n\tConsider discussion about starting statin therapy, given the ASCVD risk score >=7.5%.";
        if (!usesCholesterolLoweringMeds && ascvdScore >= 7.5) {
            recommendationString += considerStatinsString;
        }
        var recommendation = new Recommendation_1.default();
        if (historyOfCVD) {
            recommendationString = RecommendationAlgorithm.nonPrimaryPreventionText(recommendationString);
        }
        recommendation.recommendationText = recommendationString;
        recommendation.recommendationText = RecommendationAlgorithm.fixPunctuation(recommendation.recommendationText);
        return recommendation;
    };
    RecommendationAlgorithm.displayNameForBleedingRisk = function (risk) {
        var displayName = null;
        if (risk == bleedingRisk.kBleedingRiskAge) {
            displayName = "Age>60";
        }
        else if (risk == bleedingRisk.kBleedingRiskNSAID) {
            displayName = "NSAID use";
        }
        else if (risk == bleedingRisk.kBleedingRiskCoagulant) {
            displayName = "Atrial fibrillation/anticoagulant";
        }
        else if (risk == bleedingRisk.kBleedingRiskPrednisone) {
            displayName = "Prednisone/Systemic Corticosteroids use";
        }
        else if (risk == bleedingRisk.kBleedingRiskDyspepsia) {
            displayName = "Upper gastrointestinal pain or dyspepsia";
        }
        else if (risk == bleedingRisk.kBleedingRiskUlcer) {
            displayName = "Prior peptic ulcer";
        }
        else if (risk == bleedingRisk.kBleedingRiskComplicatedUlcer) {
            displayName = "Peptic ulcer complicated by bleeding or perforation";
        }
        else if (risk == bleedingRisk.kBleedingRiskMale) {
            displayName = "Male";
        }
        return displayName;
    };
    RecommendationAlgorithm.nonPrimaryPreventionText = function (primaryPreventionText) {
        var adjusted = primaryPreventionText.replace("in the primary prevention setting", "");
        adjusted = adjusted.replace("in primary prevention", "");
        adjusted = adjusted.replace(" and who are willing to take long-term therapy,", "");
        adjusted = adjusted.replace(" and who are willing to take long-term therapy", "");
        return adjusted;
    };
    RecommendationAlgorithm.fixPunctuation = function (recommendationText) {
        var fixed = recommendationText.replace(" . ", ". ");
        fixed = fixed.replace(" .\n", ".\n");
        return fixed;
    };
    RecommendationAlgorithm.prototype.hasMajorContraindicationsToAspirinRecommendation = function (historyOfCVD) {
        var recommendation = new Recommendation_1.default();
        recommendation.recommendationText = "In the primary prevention setting, patients with one or more major contraindications to aspirin should generally avoid aspirin use. However, if the patient has a remote history of GI bleed and CVD risk is high, consider continuing with the app to compare the patient’s ASCVD and bleeding risk scores and conduct a more detailed assessment of the balance of benefits and risks for the patient.";
        if (historyOfCVD) {
            recommendation.recommendationText = recommendation.recommendationText.replace("primary prevention setting", "prevention setting");
        }
        return recommendation;
    };
    RecommendationAlgorithm.prototype.patientPregnantRecommendation = function () {
        var recommendation = new Recommendation_1.default();
        recommendation.recommendationText = "Aspirin therapy for primary prevention of ASCVD in pregnant women is generally not advised. However, pregnant women who are at increased risk for preeclampsia (e.g. history of preeclampsia, multifetal gestation, chronic hypertension, diabetes, renal disease, autoimmune disease) and have no major contraindications to aspirin therapy may be advised by their healthcare provider to take low-dose aspirin after the 12th week of pregnancy to prevent preeclampsia-related complications.[[6]]";
        return recommendation;
    };
    RecommendationAlgorithm.prototype.atrialFibrillationRecommendation = function () {
        var recommendation = new Recommendation_1.default();
        recommendation.recommendationText = "Decision making regarding the use of aspirin in the setting of atrial fibrillation or among patients already taking antiplatelet or anticoagulant medication is beyond the scope of this app.";
        return recommendation;
    };
    RecommendationAlgorithm.prototype.tooYoungRecommendation = function () {
        var recommendation = new Recommendation_1.default();
        recommendation.recommendationText = "Individuals below the age of 40 years are generally not appropriate candidates for regular aspirin use for the primary prevention of ASCVD (due to their low risk of ASCVD).\n\nThis app provides guidance for patients 40 and older.";
        return recommendation;
    };
    RecommendationAlgorithm.prototype.tooOld80Recommendation = function () {
        var recommendation = new Recommendation_1.default();
        recommendation.recommendationText = "Individuals above the age of 80 years are generally not appropriate candidates for regular aspirin use for the primary prevention of ASCVD (due to sparse data on benefits and risks).\n\tThis app provides guidance for patients below age 80.";
        return recommendation;
    };
    RecommendationAlgorithm.appBackgroundText = function () {
        return "This updated version of Aspirin Guide (2022) is based on a synthesis of recent guidelines on aspirin use in the primary prevention of atherosclerotic cardiovascular disease (ASCVD) from the below sources (full references at the end):\n\n    a) The American College of Cardiology (ACC)/American Heart Association (AHA) (Arnett D, et al., 2019 ACC/AHA guideline on the primary prevention of cardiovascular disease. Circulation 2019).\n    b) The European Society of Cardiology (Visseren FLJ, et al. 2021 ESC Guidelines on cardiovascular disease prevention in clinical practice: European Heart Journal 2021.\n    c) U.S. Preventive Services Task Force. Aspirin Use to Prevent Cardiovascular Disease: U.S. Preventive Services Task Force recommendation statement. JAMA 2022. Published online April 26, 2022. doi:10.1001/jama.2022.4983\n    d) Guirguis-Blake JM EC, Perdue LA, Bean SI, Senger CA. . Aspirin Use to Prevent Cardiovascular Disease and Colorectal Cancer: An Evidence Update for the U.S. Preventive Services Task Force. JAMA 2022. Published online April 26, 2022. doi:10.1001/jama.2022.3337\n    e) The American Diabetes Association\u2019s (ADA\u2019s) Standards of Medical Care in Diabetes 2022 (Diabetes Care 2022;45(Suppl. 1):S144\u2013S174 | https://doi.org/10.2337/dc22-S010)\n    f) Mora S, Shufelt CL, Manson JE.  Whom to treat for primary prevention of atherosclerotic cardiovascular disease: The aspirin dilemma. JAMA Intern Med. Published online April 26, 2022. doi:10.1001/jamainternmed.2022.1365\n\nBased on the above references (a-e) and using information about the patient's risk factors, the Aspirin-Guide app calculates a 10-yr\u00A0ASCVD risk score (the ACC/AHA ASCVD score (a) and a bleeding risk score on aspirin therapy (based on published studies and the 2016 and 2022 USPSTF evidence synthesis) for\u00A0bleeding risk assessment for the patient [d f, g), and provides guidance for balancing the benefits and risks.  As a brief summary, the updated app recommends limited use of aspirin in primary prevention of ASCVD, with candidates meeting the following criteria: 1) Ages 40-59 with 10-year ASCVD risk score \u2265 10%; 2) Ages 60-69 with 10-year ASCVD risk score \u2265 20% or with diabetes and risk score \u2265 10%; 3) no excess bleeding risk; 4) estimation of benefit:risk ratio, based on ASCVD risk score vs bleeding risk score, is favorable (the app\u2019s calculation of number needed to treat [NNT] is less than number needed to harm [NNH]); and 5) Patient is receptive to aspirin based on shared decision making.\n\nA web-based version of Aspirin-Guide is available at www.aspiringuide.com and is accessible from any computer or smartphone. Aspirin-Guide is also available on iOS devices, allowing emailing of recommendations to the patient. Additional references relevant to the app are listed below.\n\nAbout the app developers:\n\nSamia Mora, MD, MHS, is a cardiologist and cardiovascular epidemiologist at Brigham and Women's Hospital and an Associate Professor at Harvard Medical School.\nJoAnn Manson, MD, DrPH, is a physician and cardiovascular epidemiologist at Brigham and Women's Hospital and a Professor at Harvard Medical School.\nJeffrey Ames, BS, MEng, is a computer programmer who develops medical apps\n";
        ;
    };
    RecommendationAlgorithm.shortDisclaimer = function () {
        return "Disclaimer: This Application is intended for healthcare professionals for informational purposes only and is not intended as a substitute for professional medical judgement, diagnosis, or treatment. It should not be used by patients without direct consultation with, and supervision by, their healthcare provider.";
    };
    RecommendationAlgorithm.testNNT = function () {
        var riskScores = [5, 10, 15, 20, 25, 30];
        for (var _i = 0, riskScores_1 = riskScores; _i < riskScores_1.length; _i++) {
            var i = riskScores_1[_i];
            var nnt = ASCVDRiskCalculator_1.default.NNTForScore(i);
            console.log('risk score: ' + i + ' nnt: ' + nnt);
        }
    };
    return RecommendationAlgorithm;
}());
exports.default = RecommendationAlgorithm;
//# sourceMappingURL=RecommendationAlgorithm.js.map


/** WEBPACK FOOTER **
 ** ./src/models/RecommendationAlgorithm.js
 **/